import React from 'react';

const WelcomeSection = ({ data, secdata }) => {
  const heading = data?.heading || "Welcome to Shelly";
  const subHeading = data?.subHeading || "Nunc consectetur ex nunc, id porttitor leo semper eget. Vivamus interdum, mauris quis cursus sodales, urn";
  const rawCards = data?.advanceData?.data;
  const cards = Array.isArray(rawCards) ? rawCards : [];

  // Animation variants
  // const leftVariant = {
  //   hidden: { opacity: 0, x: -100 },
  //   visible: { opacity: 1, x: 0 },
  // };

  // const rightVariant = {
  //   hidden: { opacity: 0, x: 100 },
  //   visible: { opacity: 1, x: 0 },
  // };

  const renderIcon = (name) => {
    if (!name) return null;

    const iconName = String(name).toLowerCase();
    const path =
      iconName.includes("certificate")
        ? "M12 2l2.4 4.9 5.5.8-4 3.9.9 5.5-4.8-2.5-4.8 2.5.9-5.5-4-3.9 5.5-.8L12 2zm0 4.4l-1.2 2.5-2.7.4 2 1.9-.5 2.7 2.4-1.3 2.4 1.3-.5-2.7 2-1.9-2.7-.4-1.2-2.5z"
        : iconName.includes("teacher")
          ? "M12 12a4 4 0 100-8 4 4 0 000 8zm0 2c-4 0-8 2-8 4v2h16v-2c0-2-4-4-8-4z"
          : iconName.includes("suitcase")
            ? "M9 3h6a1 1 0 011 1v2h3a1 1 0 011 1v13a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h3V4a1 1 0 011-1zm2 3h2V5h-2v1zM7 8v2h2V8H7zm4 0v2h2V8h-2zm4 0v2h2V8h-2z"
            : "M12 2l2.4 4.9 5.5.8-4 3.9.9 5.5-4.8-2.5-4.8 2.5.9-5.5-4-3.9 5.5-.8L12 2z";

    return (
      <svg viewBox="0 0 24 24" width="64" height="64" fill="currentColor" aria-hidden="true">
        <path d={path} />
      </svg>
    );
  };

  return (
    <div className="bg-white relative z-20">
      {/* Header */}
      <div className="text-center py-16 bg-gradient-to-r from-[#334821]/10 to-[#f1bb62]/10">
        <h2 className="text-4xl font-bold text-[#334821]">{heading}</h2>
        <div className="w-24 h-1 bg-[#f1bb62] mx-auto my-4"></div>
        <p className="mt-2 text-lg text-gray-600 max-w-2xl mx-auto px-4">
          {subHeading}
        </p>
      </div>

      {/* Cards */}
      {/* <div className="container mx-auto -mt-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {cards.map((card, index) => (
            <motion.div
              key={card.id}
              className="bg-white rounded-lg shadow-lg p-6 flex flex-col items-center text-center transition-transform border-t-4 border-[#f1bb62]"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              variants={index % 4 < 2 ? leftVariant : rightVariant}
            >
              <div className="mb-4 text-[#f1bb62]">
                {card.icon ? (
                  <img
                    src={card.icon}
                    alt={card.title}
                    width={64}
                    height={64}
                    className="h-16 w-16 object-contain"
                    loading="lazy"
                    decoding="async"
                  />
                ) : renderIcon(card.iconName)}
              </div>
              <div>
                <h3 className="font-semibold text-lg text-[#334821] mb-2">{card.title}</h3>
                <div
                  className="text-sm text-gray-600"
                  dangerouslySetInnerHTML={{ __html: card.desci }}
                ></div>
              </div>
            </motion.div>
          ))}
        </div>
      </div> */}
      <div className="container mx-auto -mt-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {cards.map((card, index) => (
            <div
              key={card.id}
              className="bg-white rounded-lg shadow-lg p-6 flex flex-col items-center text-center transition-transform border-t-4 border-[#f1bb62]"

            >
              <div className="mb-4 text-[#f1bb62]">
                {card.icon ? (
                  <img
                    src={card.icon}
                    alt={card.title}
                    width={64}
                    height={64}
                    className="h-16 w-16 object-contain"
                    loading="lazy"
                    decoding="async"
                  />
                ) : renderIcon(card.iconName)}
              </div>
              <div>
                <h3 className="font-semibold text-lg text-[#334821] mb-2">{card.title}</h3>
                <div
                  className="text-sm text-gray-600"
                  dangerouslySetInnerHTML={{ __html: card.desci }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Image Section */}
      <div className="container mx-auto py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {Array.isArray(secdata?.advanceData?.data) && secdata.advanceData.data.map((card, index) => (
            <div
              key={index}
              className="relative group overflow-hidden rounded-lg shadow-lg h-64"
            >
              <img
                src={card.link || 'https://via.placeholder.com/400x300'}
                alt={card.title}
                width={400}
                height={300}
                className="w-full h-full object-cover rounded-lg transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
                decoding="async"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#334821] to-transparent opacity-70 rounded-lg"></div>
              {card.title && (
                <div className="absolute bottom-0 left-0 w-full p-4 text-white">
                  <h3 className="text-lg font-semibold">{card.title}</h3>
                  {card.description && (
                    <p className="text-sm text-[#f1bb62]">{card.description}</p>
                  )}
                </div>
              )}
              {/* Corner Borders */}
              {['top-0 left-0', 'top-0 right-0', 'bottom-0 left-0', 'bottom-0 right-0'].map((pos, i) => (
                <div
                  key={i}
                  className={`absolute ${pos} w-4 h-4 border-4 border-[#f1bb62] m-3 opacity-0 group-hover:opacity-100 transition-opacity`}
                  style={{
                    borderTop: pos.includes('top') ? '4px solid #f1bb62' : '',
                    borderBottom: pos.includes('bottom') ? '4px solid #f1bb62' : '',
                    borderLeft: pos.includes('left') ? '4px solid #f1bb62' : '',
                    borderRight: pos.includes('right') ? '4px solid #f1bb62' : '',
                  }}
                ></div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WelcomeSection;
